import { Component } from "@angular/core";

@Component({
  selector: "ggc-map-details-container",
  templateUrl: "./ggc-map-details-container.component.html",
  styleUrls: ["./ggc-map-details-container.component.css"]
})
export class GgcMapDetailsContainerComponent {}
